import "@hotwired/turbo-rails"
import "./chartkick"
import "./controllers"
import { initMetaPixel } from "./meta_pixel"

initMetaPixel()

import "trix"
import "@rails/actiontext"
